/**
 * F2f — Expenses FE wrapper.
 */

import type {
  Expense,
  ExpenseCreateInput,
  ExpenseUpdateInput,
} from '@pta/types';
import { apiCall } from './client';

export interface ExpensesListParams {
  requirementId?: number;
  fromDate?: string;
  toDate?: string;
  limit?: number;
  offset?: number;
}

export function fetchGroupExpenses(
  groupId: number,
  params?: ExpensesListParams,
): Promise<Expense[]> {
  return apiCall(`/groups/${groupId}/expenses`, {
    query: {
      requirementId: params?.requirementId,
      fromDate: params?.fromDate,
      toDate: params?.toDate,
      limit: params?.limit,
      offset: params?.offset,
    },
  });
}

export function fetchExpense(id: number): Promise<Expense> {
  return apiCall(`/expenses/${id}`);
}

export function createExpense(
  groupId: number,
  input: ExpenseCreateInput,
): Promise<Expense> {
  return apiCall(`/groups/${groupId}/expenses`, {
    method: 'POST',
    body: input,
  });
}

export function updateExpense(
  id: number,
  input: ExpenseUpdateInput,
): Promise<Expense> {
  return apiCall(`/expenses/${id}`, { method: 'PATCH', body: input });
}

export function deleteExpense(id: number): Promise<Expense> {
  return apiCall(`/expenses/${id}`, { method: 'DELETE' });
}
